import { Wormhole } from 'portal-vue';
import Vue from 'vue';

export default Vue.extend({
	methods: {
		portalExists(name: string): boolean {
			return Wormhole.hasTarget(name);
		},
	},
});
